import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import Avatar from './avatar';
import { InvitedPresenter } from '../app-entry/producer/meeting-modal';
import useProfile from '../../hooks/use-profile';

export interface SelectUserProps {
	user: InvitedPresenter,
	handleChange: (u: InvitedPresenter) => void,
	selected: boolean,
	single?: boolean,
}

export default function SelectUsersRow(props: SelectUserProps) {
	const {handleChange, selected, single, user} = props;
	const {watchedProfile} = useProfile({suggestedProfile: user.gr_user});
	const u = watchedProfile ? {...user, ...watchedProfile} : user;
	// defaulting to email for single select. Makes email left-aligned in multi-select list when no name.
	const firstLabel = (u.first_name || u.last_name)
		? `${u?.first_name ?? '' }${u?.first_name ? ' ' : ''}${u?.last_name ?? ''}` 
		: u.email;
	// single select has name OR email. Multiselect has both unless unnamed.
	const secondLabel = (!single && firstLabel !== u.email) ? u.email : false;
	return (
		<div
			onClick={() => { handleChange(u) }}
			className={classNames("select-users-option checkbox bl-font-p2", { selected })}
		>
			<Avatar noBorder={true} user={u} size={'twentyfour'}/>
			{firstLabel ? <label className='first-label bl-font-p2 truncate-overflow'>{firstLabel}</label> : null}
			{secondLabel ? <span className='second-label bl-font-p2 truncate-overflow'>{user.email}</span> : null}
			{single ? null : <div className="checkbox-outer"><FontAwesomeIcon icon={faCheck} /></div>}
		</div>
	)
}
